import { Magazine } from "../Datatypes";

export const useFilterMagazines = (
  availableMagazines: Magazine[],
  dateFilter: string | null,
  editionFilter: string | null
): Magazine[] => {
  return availableMagazines.filter((m) => {
    const isDateMatch = !dateFilter || m.date === dateFilter;
    const isEditionMatch = !editionFilter || m.edition === editionFilter;
    return isDateMatch && isEditionMatch;
  });
};